import axios from 'axios';

const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search';

/**
 * Fetch address suggestions for autocomplete
 * Uses Mapbox Geocoding API for better support of full addresses with house numbers
 * @param {string} query - Search query
 * @param {number} limit - Max number of results (default 5)
 * @returns {Promise<Array<{displayName: string, lat: string, lon: string}>>}
 */
export { fetchAddressSuggestions } from './MapboxService';

/**
 * Fetch region/area suggestions with polygon data
 * @param {string} query - Search query (e.g., "Hungary", "Budapest")
 * @param {number} limit - Max number of results (default 5)
 * @returns {Promise<Array>}
 */
export async function fetchRegionSuggestions(query, limit = 5) {
  if (!query || query.length < 2) {
    return [];
  }

  try {
    const response = await axios.get(NOMINATIM_URL, {
      params: {
        q: query,
        format: 'json',
        addressdetails: 1,
        limit,
        polygon_geojson: 1, // Request polygon data
      },
      headers: {
        'Accept-Language': 'en',
      },
    });

    if (response.data && response.data.length > 0) {
      return response.data
        .filter((result) => result.geojson) // Only include results with polygon data
        .map((result) => ({
          displayName: result.display_name,
          lat: result.lat,
          lon: result.lon,
          type: result.type,
          class: result.class,
          geojson: result.geojson,
          boundingbox: result.boundingbox,
        }));
    }
  } catch (error) {
    // Error fetching region suggestions
  }
  return [];
}
